export default "__VITE_ASSET__he1NY8aw__"